<template>
  <modal-layout>
    <div class="layer_section-container">
      <div class="layer-content">
        <div class="pop-orderCancel-area">
          <p class="tit tit_new">
            {{ computedText }}
            <br>
            {{ computedSubText }}
          </p>
        </div>
      </div>
      <div class="align-box size-auto">
        <button
          type="button"
          class="btn-modal_confirm"
          @click="onCancel"
        >
          취소
        </button>
        <button
          type="button"
          class="btn-modal_close v2"
          @click="onConfirm"
        >
          확인
        </button>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/components/global/ModalLayout.vue';
import { log } from '@/utils/common';
import modalMixin from './modal-mixin';

export default {
  name: 'ModalConfirm',
  components: {
    ModalLayout,

  },
  mixins: [modalMixin],
  props: {
    text: {
      type: String,
      default: 'fill me',
    },
    subText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      message: '',
      subMessage: '',
    };
  },
  computed: {
    computedText() {
      return this.message ? this.message : this.text;
    },
    computedSubText() {
      return this.subMessage ? this.subMessage : this.subText;
    },
  },
  watch: {

  },
  created() {

  },
  mounted() {
    this.confirmPromise = null;
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onConfirm() {
      if (this.confirmPromise) {
        this.resolve();
      }
      this.$emit('confirm');
      this.close();
    },
    onBeforeDispose() {
      log('ModalConfirm::onBeforeDispose', 'before-dispose');
    },
    onCancel() {
      if (this.confirmPromise) {
        this.reject();
      }
      this.$emit('cancel');
      this.close();
    },
    openWithMessage(msg) {
      this.confirmPromise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      this.message = msg;
      this.open();

      return this.confirmPromise;
    },
  },
};
</script>
<style scoped>
.type-wide-a .layer_section-container {
  min-width: 360px;
  min-height: 120px;
}

.layer_section.type-wide-a .layer_section-container .layer-content {
  min-height: 120px;
  width: 100%;
  /* height: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn_group div {
  margin-left: 0;
}

.coupon_content-item .btn_group button ~ button {
  margin-left: 0;
}

@media( max-width: 768px) {
  .btn_group div .layer_section-container {
    display: block;
  }
}

</style>
